import React, { ChangeEvent, useEffect, useState } from "react";
import { ErrorMessage, Field, useField, useFormikContext } from "formik";
import { useReactiveVar } from "@apollo/client";
import { currencySingVar } from "@me-team/host/main/globalVar/state";
import { roundTo2Safe } from "../utils/utils";

interface PriceInputProps {
    name: string;
    placeholder: string;
    initialValue?: number;
    id: string;
    disabled?: boolean;
}

const PriceSaleInput: React.FC<PriceInputProps> = ({ name, placeholder, initialValue, id, disabled }) => {
    const currencySing = useReactiveVar(currencySingVar);
    const { setFieldValue, setFieldTouched } = useFormikContext();
    const [field, meta] = useField(name);
    const [price, setPrice] = useState("");

    useEffect(() => {
        if (initialValue !== undefined && initialValue !== null) {
            const safe = roundTo2Safe(Number(initialValue));
            setPrice(safe !== null ? safe.toFixed(2) : "");
        } else {
            setPrice("");
        }
    }, [initialValue]);

    const handlePriceChange = (e: ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        const value = e.target.value.trim();
        const regex = /^(?!0\d)\d{0,6}(\.\d{0,2})?$/;
        if (regex.test(value) || value === "") {
            setPrice(value);
        }
    };

    const handleBlurPrice = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value.trim();
        if (value === "") {
            setPrice("");
            setFieldTouched(name, true, true);
            setFieldValue(name, null);
        } else {
            const numericPrice = parseFloat(value);
            if (!isNaN(numericPrice)) {
                const safe = roundTo2Safe(numericPrice);
                setPrice(safe!.toFixed(2));
                setFieldValue(name, safe);
            } else {
                setPrice("");
                setFieldValue(name, null);
            }
        }
    };

    return (
        <div className="position-relative">
            <Field
                name={name}
                type="text"
                id={id}
                placeholder={placeholder}
                value={price !== null ? price.toString() : ""}
                className={`form-control ${meta.touched && meta.error ? "is-invalid" : ""}`}
                onBlur={handleBlurPrice}
                onChange={handlePriceChange}
                disabled={disabled}
            />
            <i
                className={`position-absolute fs-7 end-0 top-50 translate-middle-y text-dark me-2 pe-3
             ${meta.touched && meta.error ? "d-none" : ""}`}
            >
                {currencySing}
            </i>
            <ErrorMessage name={name}>{(msg) => <div className="invalid-feedback">{msg}</div>}</ErrorMessage>
        </div>
    );
};

export default PriceSaleInput;
